<template>
  <div class="portlet-body form">
    <div v-show="loading > 0" class="row">
      <div class="col-sm-12">
        <span>
          <div class="progress" style="margin: 20px 0;">
              <div
                :aria-valuemax="progress"
                :aria-valuenow="loading"
                :style="{ width: currentProgress + '%' }"
                aria-valuemin="0"
                class="progress-bar"
                role="progressbar"
              >
                  <span class="sr-only">{{ currentProgress }}% Complete</span>
              </div>
          </div>
          <h2 v-if="$store.state.dateDataIsLoading">{{ trans('form.copying') }}...</h2>
          <h2 v-else>{{ trans('form.please_wait') }}...</h2>
          <ring-loader/>
        </span>
      </div>
    </div>
    <div v-show="loading <= 0" class="row">
      <div class="col-sm-12">
        <form>
          <div class="row">
            <div class="col-md-12">
              <div class="btn-set pull-right">
                <button class="btn green" @click="showMenu">{{ trans('menu_planner.show') }}</button>
              </div>
              <div class="btn-set pull-right" style="margin-right:8px;">
                <menu-planner-history
                  :brand="brand"
                  :date="date"
                  route-name="api_get_entity_logger_show_menu_planner_serving"
                />
              </div>
            </div>
          </div>
          <div v-for="(variant, variantIndex) in variants" :key="variantIndex" class="row">
            <menu-planner-edit-variant
              :brand="brand"
              :date="date"
              :meal-types="mealTypes"
              :variant="variant"
              @loading-start="loadingStart"
              @loading-stop="loadingStop"
            />
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import moment from 'moment'
import RingLoader from 'vue-spinner/src/RingLoader.vue'
import MenuPlannerEditVariant from './MenuPlannerEditVariant.vue'
import MenuPlannerHistory from '@component/view/MenuPlannerHistory.vue'

export default {
  components: {
    MenuPlannerHistory,
    RingLoader,
    MenuPlannerEditVariant,
  },
  props: {
    date: {
      type: [String, Date],
      default: ''
    },
    showDate: {
      type: [String, Date],
      default: ''
    },
    brand: {
      type: [String, Number],
      default: ''
    },
    package: {
      type: [String, Number],
      default: ''
    },
  },
  data() {
    return {
      loading: 0,
      progress: 0,
      brands: [],
      mealTypes: [],
      variants: [],
      errors: {},
      meals: {},
    }
  },
  computed: {
    currentProgress() {
      if (this.progress === 0) {
        return 0
      }
      let progressCmptd = (1 - this.loading / this.progress) * 100

      if (progressCmptd >= 100) {
        this.$store.commit('setEditViewLoading', false)
      }

      return progressCmptd
    }
  },
  watch: {
    '$store.state.dateDataIsLoading'(value) {
      if (value) {
        this.loadingStart()
      } else {
        this.loadingStop()
        this.getVariants()
      }
    }
  },
  mounted() {
    if (!this.isGranted() || !this.canEdit()) {
      this.showMenu()
    }

    this.getMealTypes()
    this.getVariants()
  },
  methods: {
    showMenu() {
      const location = {
        name: 'menu-planner-show',
        params: {
          date: this.showDate,
          brand: this.brand
        }
      }

      if (this.package) {
        location.query = {
          package: this.package
        }
      }

      this.$router.push(location)
    },
    getVariants() {
      this.loadingStart()
      this.variants = []
      let url = Routing.generate('api_get_menu_planner_variant', {
        context: 'list',
        brand: this.brand
      })

      if (this.package) {
        url += `?package=${this.package}`
      }

      Vue.http.get(url).then(response => {
        this.variants = response.data
        this.loadingStop()
      }, response => {
        this.handleAjaxError(response)
        this.loadingStop()
      })
    },
    getMealTypes() {
      this.loadingStart()
      const url = Routing.generate('api_get_meal_types', { context: 'dropdown' })
      this.$http.get(url).then(response => {
        this.mealTypes = response.data
        this.loadingStop()
      }, response => {
        this.handleAjaxError(response)
        this.loadingStop()
      })
    },
    trans(id) {
      return Translator.trans(id)
    },
    loadingStart() {
      this.loading++
      this.progress++
    },
    loadingStop() {
      this.loading--
    },
    isGranted() {
      return Object.values(window.appValues.menuPlanner.permissions).indexOf('MENU_PLANNER_UPDATE') !== -1
    },
    canEdit(date) {
      return (new moment(date)).unix() >= (new moment((new moment()).format('YYYY-MM-DD'))).unix()
    },
  },
}
</script>
